import sanityConfig from '../../sanity.config';
import {Image} from '@shopify/hydrogen';
import imageUrlBuilder from '@sanity/image-url';
interface SkiTestHookProps {
  skiTest: any;
  yearNumber: number;
}

export function SkiTestHook({skiTest, yearNumber}: SkiTestHookProps) {
  return (
    <div className="hero">
      <div className="overlay">
        <div className="header absolute bottom-[70px] lg:bottom-[50px] left-4 lg:left-[50px]">
          <h1
            className="font-libre-baskerville font-semibold text-[50px] md:text-[6vw] leading-tight mb-2"
            style={{textShadow: '2px 2px 15px #777777'}}
          >
            {skiTest?.title}
          </h1>
          <div className="text-3xl lg:text-5xl  flex-col lg:flex-row pr-10 gap-2 hidden lg:flex">
            <Image
              className="w-[120px] h-[120px] mr-5"
              src="/2025-ski-test-logo.png"
              alt=""
              width="auto"
              height="auto"
            />
            <h2 className="inline-flex flex-col">
              <span
                className="font-semibold pb-2"
                style={{textShadow: '2px 2px 15px #777777'}}
              >
                {yearNumber} SkiEssentials Ski Test
              </span>
              <span
                className="italic text-lg"
                style={{textShadow: '2px 2px 15px #777777'}}
              >
                {skiTest?.hook?.subtitle}
              </span>
            </h2>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 w-full flex justify-cente lg:hidden">
          <Image
            loading="lazy"
            className="w-full max-w-[350px] mx-auto object-contain"
            src={'/2025-ski-test.png'}
            alt={`ski test sidebar`}
            width={300}
            height={80}
          />
        </div>
      </div>
      {skiTest?.hook?.image?.asset && (
        <div
          className="parallax-background"
          style={{
            filter: 'brightness(0.75) contrast(1.45)',
            backgroundImage: `url(${imageUrlBuilder(sanityConfig)
              .image({
                _ref: skiTest.hook.image.asset._ref,
              })
              .quality(80)})`,
          }}
        />
      )}
    </div>
  );
}
